module.exports = __webpack_public_path__ + "static/media/transparent.a22d5a51.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/transparent.png
// module id = 369
// module chunks = 0